import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { Typography } from '../../../global/theme';
import { AlignCenter, FlexCenter } from '../../../global/commonStyle';

interface Props {
  isActive?: boolean;
  selectedUsers?: boolean;
  isDisabled?: boolean;
}

// Multi-select input with tags styled components
export const InputSectionDiv = styled.div<Props>`
  width: 100%;
  padding-left: ${({ selectedUsers }) => (selectedUsers ? 'var(--space-0)' : 'var(--space-7)')};
  border-radius: var(--border-radius-6);
  background-color: var(--background-primary);
  display: flex;
  align-items: flex-start;
  gap: var(--space-8);
  ${mobile_xl(css`
    min-width: calc(100vw - 90px);
  `)}
`;

export const ProfileSection = styled.div`
  width: calc(100% - 25px);
  ${AlignCenter}
  flex-wrap: wrap;
  gap: var(--space-4);
  overflow: hidden;
`;

export const InputDiv = styled.div`
  flex-grow: 1;
  display: inline-flex;
  position: relative;
`;

export const DummySpan = styled.span<Props>`
  max-width: 358px;
  flex-shrink: 1;
  box-sizing: border-box;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: 0;
  overflow: hidden;
  ${Typography.body_lg}
  color: var(--text-primary);
  padding: var(--space-3) var(--space-0) var(--space-3) var(--space-3);
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      cursor: not-allowed;
      color: var(--text-muted);
      &::placeholder {
        color: var(--text-muted);
      }
      &:hover {
        border-color: var(--border-primary);
      }
    `}
`;

export const TagInput = styled.input`
  max-width: 358px;
  width: 100%;
  height: 100%;
  max-height: 26px;
  padding: var(--space-0);
  position: absolute;
  top: 0;
  left: 0;
  border: none;
  outline: none;
  ${Typography.body_lg}
  color: var(--text-primary);
  background: var(--background-primary);
  &:disabled {
    cursor: not-allowed;
    color: var(--text-muted);
    &::placeholder {
      color: var(--text-muted);
    }
    &:hover {
      border-color: var(--border-primary);
    }
  }
  ::placeholder {
    color: var(--text-placeholder);
  }
  &:focus-visible {
    border-color: var(--brand-primary);
    outline: unset;
  }
  ${mobile_xl(css`
    max-height: 28px;
  `)}
`;

export const TagIconDiv = styled.div`
  ${FlexCenter}
  padding-top: var(--space-4);
  cursor: pointer;
  .angleDown-icon {
    transition: transform var(--transition-normal) ease;
  }
  .angleDown-icon.rotate {
    transform: rotate(180deg);
  }
`;
